function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPromotionBestOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.221 25.186L7.798 30.62l-1.026-5.126-5.126-1.026 4.255-4.244a12.303 12.303 0 007.32 4.962zM16 4.988a8.202 8.202 0 110 16.404 8.202 8.202 0 010-16.404zm0-2.05a10.253 10.253 0 100 20.505 10.253 10.253 0 000-20.506zm14.354 21.53l-5.127 1.026-1.025 5.126-5.434-5.434a12.365 12.365 0 007.33-4.962l4.256 4.244z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.18 17.14v-6.324l-1.464 1.152-.576-1.416 2.28-1.692h1.44v8.28h-1.68z",
    fill: props.color
  }));
}

export default SvgIconPromotionBestOutline;